import Vue from 'vue';
import Vuex from 'vuex';
import { IUserState } from './user';
import { INiceState } from './nice';

Vue.use(Vuex);

export interface IRootState {
  user: IUserState
  nice: INiceState
}

export default new Vuex.Store<IRootState>({});
